import { facebook, twitter, youtube, twitch, vk } from "./Socialicons";

const socialIconsData = {
  facebook: { icon: facebook, name: "Facebook" },
  twitter: { icon: twitter, name: "Twitter" },
  youtube: { icon: youtube, name: "Youtube" },
  twitch: { icon: twitch, name: "Twitch" },
  vk: { icon: vk, name: "VK" }
};

const generateList = list => {
  return list.map(item => {
    return { ...item, ...socialIconsData[item.type] };
  });
};

export default generateList;
